export const MARKER_BRAND_PACIFICBLUE = "brand_pacificblue_marker";
